(() => {
  const money = (cents, currency) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format((Number(cents) || 0) / 100);

  const updateBundle = (bundle) => {
    if (!bundle) return;

    const selectedItems = Array.from(bundle.querySelectorAll('[data-alard-bundle-item]:checked:not(:disabled)'));
    const total = selectedItems.reduce((sum, item) => sum + Number(item.dataset.price || 0), 0);
    const compareTotal = selectedItems.reduce(
      (sum, item) => sum + Number(item.dataset.comparePrice || item.dataset.price || 0),
      0
    );
    const currency = bundle.closest('[data-alard-product]')?.dataset.currency || 'USD';
    const totalElement = bundle.querySelector('[data-alard-bundle-total]');
    const discountElement = bundle.querySelector('[data-alard-bundle-discount]');
    const compareElement = bundle.querySelector('[data-alard-bundle-compare]');
    const addButton = bundle.querySelector('[data-alard-add-bundle]');

    if (totalElement) totalElement.textContent = money(total, currency);
    const discount = compareTotal > total && compareTotal > 0
      ? Math.round(((compareTotal - total) * 100) / compareTotal)
      : 0;
    if (discountElement) {
      discountElement.textContent = `-${discount}%`;
      discountElement.classList.toggle('is-hidden', discount === 0);
    }
    if (compareElement) {
      compareElement.textContent = money(compareTotal, currency);
      compareElement.classList.toggle('is-hidden', discount === 0);
    }
    if (addButton) {
      addButton.disabled = selectedItems.length === 0;
      addButton.textContent = selectedItems.length === 2
        ? 'Add both to cart'
        : selectedItems.length > 2
          ? `Add ${selectedItems.length} items to cart`
          : 'Add selected to cart';
    }
  };

  const activateReviews = (panel) => {
    if (!panel) return;

    const widget = panel.querySelector('[data-alard-reviews-widget]');
    const status = panel.querySelector('[data-alard-reviews-status]');
    if (!widget) return;
    const legacy = widget.querySelector(':scope > .jdgm-legacy-widget-content');
    if (legacy) legacy.style.display = '';

    const placeReviewEnhancements = () => {
      const reviewRoots = Array.from(widget.querySelectorAll('.jdgm-rev-widg'));
      const reviewRoot = reviewRoots[0];
      if (!reviewRoot) return;

      const header = reviewRoot.querySelector('.jdgm-rev-widg__header');
      const title = header?.querySelector('.jdgm-rev-widg__title');
      const originalSummary = header?.querySelector('.jdgm-rev-widg__summary');
      const histogram = header?.querySelector('.jdgm-histogram');
      const overview = panel.querySelector('[data-alard-review-overview]');
      if (header && overview && histogram) {
        let summaryCard = header.querySelector('.main-product-alard__review-summary-card');
        if (!summaryCard) {
          summaryCard = document.createElement('div');
          summaryCard.className = 'main-product-alard__review-summary-card';
          if (title) title.insertAdjacentElement('afterend', summaryCard);
          else header.insertBefore(summaryCard, header.firstChild);
        }

        const liveRating = reviewRoot.dataset.averageRating;
        const liveCount = reviewRoot.dataset.numberOfReviews;
        const parsedRating = Number.parseFloat(liveRating);
        const parsedCount = Number.parseInt(liveCount, 10);

        if (Number.isFinite(parsedRating)) {
          const ratingLabel = parsedRating.toFixed(1);
          const roundedRating = Math.round(parsedRating);
          const ratingValue = overview.querySelector('strong');
          const ratingStars = overview.querySelector('.main-product-alard__review-overview-stars');
          if (ratingValue) ratingValue.textContent = ratingLabel;
          if (ratingStars) ratingStars.setAttribute('aria-label', `${ratingLabel} out of 5 stars`);
          overview.querySelectorAll('img').forEach((star, index) => {
            star.classList.toggle('is-off', index + 1 > roundedRating);
          });
        }

        if (Number.isFinite(parsedCount)) {
          const reviewLabel = `${parsedCount} ${parsedCount === 1 ? 'review' : 'reviews'}`;
          const overviewCount = overview.querySelector(':scope > span');
          const reviewCount = panel.querySelector('[data-alard-review-count]');
          if (overviewCount) overviewCount.textContent = `Based on ${reviewLabel}`;
          if (reviewCount) reviewCount.textContent = reviewLabel;
        }

        if (originalSummary) originalSummary.hidden = true;
        if (overview.parentElement !== summaryCard) summaryCard.insertBefore(overview, summaryCard.firstChild);
        if (histogram.parentElement !== summaryCard) summaryCard.appendChild(histogram);
        overview.hidden = false;

        histogram.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach((row) => {
          const starLabel = row.querySelector('.jdgm-histogram__star');
          const frequency = row.querySelector('.jdgm-histogram__frequency');
          if (starLabel) starLabel.dataset.alardRatingLabel = `${row.dataset.rating} ★`;
          if (frequency && frequency.textContent !== row.dataset.frequency) {
            frequency.textContent = row.dataset.frequency || '0';
          }
        });

        const trust = panel.querySelector('[data-alard-review-trust]');
        if (trust) {
          if (summaryCard.nextElementSibling !== trust) summaryCard.insertAdjacentElement('afterend', trust);
          trust.hidden = false;
        }
      }

      const writeReview = header?.querySelector('.jdgm-write-rev-link');
      if (writeReview) {
        const webReviewsEnabled = window.jdgmSettings?.disable_web_reviews !== true;
        writeReview.toggleAttribute('hidden', !webReviewsEnabled);
        writeReview.setAttribute('aria-hidden', String(!webReviewsEnabled));
        if (webReviewsEnabled) {
          writeReview.removeAttribute('style');
          const fallbackReviewUrl = externalJudgeReviewUrl();
          if (fallbackReviewUrl) {
            writeReview.href = fallbackReviewUrl;
            writeReview.target = '_blank';
            writeReview.rel = 'noopener noreferrer';
          }
        }
      }

      const nativeMedals = header?.querySelector('.jdgm-medals-wrapper');
      if (nativeMedals) nativeMedals.hidden = true;

      const sortWrapper = reviewRoot.querySelector('.jdgm-rev-widg__sort-wrapper');
      const reviewCount = panel.querySelector('[data-alard-review-count]');
      if (sortWrapper && reviewCount) {
        if (reviewCount.parentElement !== sortWrapper) sortWrapper.insertBefore(reviewCount, sortWrapper.firstChild);
        reviewCount.hidden = false;
      }

      reviewRoot.querySelectorAll('.jdgm-rev__timestamp').forEach((timestamp) => {
        if (timestamp.textContent.trim() || !timestamp.dateTime) return;
        const reviewDate = new Date(timestamp.dateTime);
        if (!Number.isNaN(reviewDate.getTime())) {
          timestamp.textContent = reviewDate.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          });
          timestamp.classList.remove('jdgm-spinner');
        }
      });

      reviewRoot.querySelectorAll('.jdgm-rev__pic-img[data-src]').forEach((image) => {
        if (!image.getAttribute('src')) image.setAttribute('src', image.dataset.src);
      });

      reviewRoot.querySelectorAll('.jdgm-paginate__page').forEach((page) => {
        const isCurrent = page.classList.contains('jdgm-curt');
        if (isCurrent) {
          page.setAttribute('aria-current', 'page');
          page.setAttribute('aria-disabled', 'true');
          page.setAttribute('tabindex', '-1');
        } else {
          page.removeAttribute('aria-current');
          page.removeAttribute('aria-disabled');
          page.setAttribute('tabindex', '0');
        }
      });

      reviewRoot.classList.add('is-alard-review-layout');
    };

    const loadReviewPage = async (pageLink) => {
      const reviewRoot = pageLink.closest('.jdgm-rev-widg');
      const pagination = pageLink.closest('.jdgm-paginate');
      const reviewBody = reviewRoot?.querySelector('.jdgm-rev-widg__body');
      const page = pageLink.dataset.page;
      if (!reviewRoot || !pagination || !reviewBody || !page || pagination.classList.contains('is-loading')) return;

      const productId = widget.dataset.id || widget.dataset.productId;
      const shopDomain = window.Shopify?.shop || window.location.hostname;
      if (!productId || !pagination.dataset.url) {
        console.warn('Judge.me pagination is missing its product ID or endpoint.');
        return;
      }

      const endpoint = new URL(pagination.dataset.url, window.location.href);
      if (endpoint.hostname === 'api.judge.me') endpoint.hostname = 'cdn.judge.me';

      const params = endpoint.searchParams;
      params.set('page', page);
      params.set('per_page', pagination.dataset.perPage || '5');
      params.set('product_id', productId);
      params.set('shop_domain', shopDomain);
      params.set('url', shopDomain);
      params.set('platform', 'shopify');

      const updatedAt = reviewRoot.dataset.updatedAt;
      const updatedTimestamp = updatedAt ? Math.floor(Date.parse(updatedAt) / 1000) : 0;
      if (updatedTimestamp > 0) params.set('ts', String(updatedTimestamp));

      ['sortBy', 'sortDir', 'filterRating'].forEach((key) => {
        const value = widget.dataset[key] || reviewRoot.dataset[key];
        if (value) params.set(key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`), value);
      });

      pagination.classList.add('is-loading');
      reviewBody.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(endpoint.toString(), {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`Judge.me returned ${response.status}`);

        const payload = await response.json();
        if (!payload?.html) throw new Error('Judge.me returned an empty reviews page');

        reviewBody.innerHTML = payload.html;
        placeReviewEnhancements();
        window.requestAnimationFrame(() => {
          placeReviewEnhancements();
          reviewBody.querySelector('.jdgm-rev-widg__reviews')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        });
      } catch (error) {
        console.error('Judge.me review page could not be loaded.', error);
        if (status) {
          status.textContent = 'This review page could not be loaded. Please try again.';
          status.hidden = false;
          panel.classList.remove('is-reviews-ready');
        }
      } finally {
        pagination.classList.remove('is-loading');
        reviewBody.removeAttribute('aria-busy');
      }
    };

    const waitForJudgeReviewForm = () => new Promise((resolve, reject) => {
      const startedAt = Date.now();
      const check = () => {
        const judge = window.jdgm;
        const needsModal = Boolean(judge?.isVersion3 && window.jdgmSettings?.modal_write_review_flow);
        const hasModal = !needsModal || typeof judge?._WriteReviewModal === 'function';
        if (typeof judge?._renderAndSetupReviewForm === 'function' && judge?.$ && hasModal) {
          resolve();
          return;
        }
        if (Date.now() - startedAt >= 6000) {
          reject(new Error('Judge.me review form timed out while loading'));
          return;
        }
        window.setTimeout(check, 50);
      };
      check();
    });

    const externalJudgeReviewUrl = () => {
      const shopDomain = window.Shopify?.shop || window.location.hostname;
      const productId = widget.dataset.id || widget.dataset.productId;
      if (!shopDomain || !productId) return '';

      const url = new URL('https://api.judge.me/storefront_reviews/new');
      url.searchParams.set('shop_domain', shopDomain);
      url.searchParams.set('platform', 'shopify');
      url.searchParams.set('product_id', productId);
      url.searchParams.set('template_locale', document.documentElement.lang || 'en');
      return url.toString();
    };

    const openExternalJudgeReviewForm = () => {
      const reviewUrl = externalJudgeReviewUrl();
      if (!reviewUrl) throw new Error('Judge.me review URL could not be created');

      const reviewWindow = window.open(reviewUrl, '_blank', 'noopener,noreferrer');
      if (!reviewWindow) throw new Error('The browser blocked the Judge.me review tab');
    };

    const openJudgeReviewForm = async (writeReview) => {
      if (writeReview.getAttribute('aria-busy') === 'true') return;
      writeReview.setAttribute('aria-busy', 'true');

      try {
        const judge = window.jdgm;
        if (!judge?.loadScript || !window.jdgmSettings) {
          openExternalJudgeReviewForm();
          return;
        }
        if (window.jdgmSettings?.disable_web_reviews === true) {
          throw new Error('Writing reviews is disabled in the Judge.me app settings');
        }

        const cdnHost = judge.CDN_HOST || 'https://cdnwidget.judge.me/';
        const modalScript = `${cdnHost}widget/write_review_modal.js`;
        const formScript = `${cdnHost}widget/form.js`;
        judge.loadScript(modalScript);
        judge.loadScript(formScript);
        judge.loadCSS?.(judge.widgetPath?.('form.css') || `${cdnHost}widget/form.css`);

        window.setTimeout(() => {
          if (typeof judge._renderAndSetupReviewForm !== 'function') {
            judge.loadScript(formScript, undefined, true);
          }
          if (
            judge.isVersion3
            && window.jdgmSettings?.modal_write_review_flow
            && typeof judge._WriteReviewModal !== 'function'
          ) {
            judge.loadScript(modalScript, undefined, true);
          }
        }, 500);
        await waitForJudgeReviewForm();

        const setupComplete = new Promise((resolve) => {
          let settled = false;
          const finish = () => {
            if (settled) return;
            settled = true;
            document.removeEventListener('jdgm.doneSetupReviewForm', finish);
            resolve();
          };
          document.addEventListener('jdgm.doneSetupReviewForm', finish, { once: true });
          window.setTimeout(finish, 700);
        });

        judge._renderAndSetupReviewForm(judge.$(widget));
        await setupComplete;

        writeReview.dataset.alardNativeClick = 'true';
        writeReview.click();
      } catch (error) {
        console.error('Judge.me review form could not be opened.', error);
        if (status) {
          status.textContent = window.jdgmSettings?.disable_web_reviews === true
            ? 'Writing reviews is currently disabled in Judge.me.'
            : 'The review form could not be opened. Please try again.';
          status.hidden = false;
          panel.classList.remove('is-reviews-ready');
        }
      } finally {
        writeReview.removeAttribute('aria-busy');
      }
    };

    if (widget.dataset.alardPaginationBound !== 'true') {
      widget.dataset.alardPaginationBound = 'true';

      widget.addEventListener('click', (event) => {
        const writeReview = event.target.closest('.jdgm-write-rev-link');
        if (writeReview && widget.contains(writeReview)) {
          if (!window.jdgm?.loadScript || !window.jdgmSettings) {
            return;
          }

          if (writeReview.dataset.alardNativeClick === 'true') {
            delete writeReview.dataset.alardNativeClick;
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          openJudgeReviewForm(writeReview);
          return;
        }

        const pageLink = event.target.closest('.jdgm-paginate__page[data-page]:not(.jdgm-curt)');
        if (!pageLink || !widget.contains(pageLink)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        loadReviewPage(pageLink);
      }, true);

      widget.addEventListener('keydown', (event) => {
        const writeReview = event.target.closest('.jdgm-write-rev-link');
        if (writeReview && widget.contains(writeReview) && event.key === ' ') {
          event.preventDefault();
          writeReview.click();
          return;
        }

        const pageLink = event.target.closest('.jdgm-paginate__page[data-page]:not(.jdgm-curt)');
        if (!pageLink || !widget.contains(pageLink) || !['Enter', ' '].includes(event.key)) return;

        event.preventDefault();
        pageLink.click();
      }, true);
    }

    const hasRenderedWidget = () => {
      const hasDirectWidgetContent = widget.childElementCount > 0;
      return Boolean(widget.shadowRoot?.childElementCount || hasDirectWidgetContent || widget.classList.contains('jdgm--done-setup'));
    };

    const showWidget = () => {
      placeReviewEnhancements();
      window.requestAnimationFrame(placeReviewEnhancements);
      window.setTimeout(placeReviewEnhancements, 250);
      window.setTimeout(placeReviewEnhancements, 1000);
      window.setTimeout(placeReviewEnhancements, 2500);
      if (panel.dataset.alardReviewsObserver !== 'true') {
        panel.dataset.alardReviewsObserver = 'true';
        const reviewObserver = new MutationObserver(() => window.requestAnimationFrame(placeReviewEnhancements));
        reviewObserver.observe(widget, { childList: true, subtree: true });
      }
      if (status) status.hidden = true;
      panel.classList.add('is-reviews-ready');
    };

    if (hasRenderedWidget()) {
      try {
        window.jdgm?.initializeWidgets?.();
      } catch (error) {
        console.warn('Judge.me widget initialization was deferred.', error);
      }
      showWidget();
      window.dispatchEvent(new Event('resize'));
      return;
    }

    if (panel.dataset.alardReviewsInitialized === 'true') return;
    panel.dataset.alardReviewsInitialized = 'true';

    try {
      window.jdgm?.initializeWidgets?.();
    } catch (error) {
      console.warn('Judge.me widget initialization was deferred.', error);
    }
    window.dispatchEvent(new Event('resize'));

    const observer = new MutationObserver(() => {
      if (!hasRenderedWidget()) return;
      observer.disconnect();
      showWidget();
    });
    observer.observe(widget, { childList: true, subtree: false, attributes: true, attributeFilter: ['class'] });

    window.setTimeout(() => {
      observer.disconnect();
      if (hasRenderedWidget()) {
        showWidget();
      } else if (status) {
        status.textContent = panel.dataset.hasReviewData === 'true'
          ? 'Product reviews could not be loaded. Please refresh the page and try again.'
          : 'There are no reviews for this product yet.';
      }
    }, 2500);
  };

  const updateGallery = (root, image, mediaId, alt) => {
    const mainImage = root.querySelector('[data-alard-main-image]');
    if (mainImage && image) {
      mainImage.src = image;
      mainImage.srcset = '';
      if (alt) mainImage.alt = alt;
    }

    root.querySelectorAll('[data-alard-thumbnail]').forEach((thumbnail) => {
      const active = String(thumbnail.dataset.mediaId) === String(mediaId);
      thumbnail.classList.toggle('is-active', active);
      thumbnail.setAttribute('aria-pressed', String(active));
    });
  };

  const getLightboxSlides = (root) => {
    const thumbnails = Array.from(root.querySelectorAll('[data-alard-thumbnail]'));
    if (thumbnails.length) {
      return thumbnails.map((thumbnail) => ({
        src: thumbnail.dataset.zoomImage || thumbnail.dataset.image,
        alt: thumbnail.dataset.alt || '',
      }));
    }

    const mainImage = root.querySelector('[data-alard-main-image]');
    if (!mainImage) return [];
    return [{ src: mainImage.dataset.zoomImage || mainImage.src, alt: mainImage.alt || '' }];
  };

  const getActiveSlideIndex = (root) => {
    const thumbnails = Array.from(root.querySelectorAll('[data-alard-thumbnail]'));
    const activeIndex = thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active'));
    return activeIndex > -1 ? activeIndex : 0;
  };

  const showLightboxSlide = (lightbox, slides, index) => {
    if (!slides.length) return;
    const normalizedIndex = ((index % slides.length) + slides.length) % slides.length;
    const slide = slides[normalizedIndex];
    const image = lightbox.querySelector('[data-alard-lightbox-image]');
    if (image) {
      image.src = slide.src;
      image.alt = slide.alt;
    }
    const counter = lightbox.querySelector('[data-alard-lightbox-counter]');
    if (counter) counter.textContent = `${normalizedIndex + 1} / ${slides.length}`;
    lightbox.dataset.activeIndex = String(normalizedIndex);
  };

  const openLightbox = (root, startIndex, trigger) => {
    const lightbox = root.querySelector('[data-alard-lightbox]');
    const slides = getLightboxSlides(root);
    if (!lightbox || !slides.length) return;

    lightbox.alardTrigger = trigger || null;
    showLightboxSlide(lightbox, slides, startIndex);
    lightbox.hidden = false;
    document.body.classList.add('overflow-hidden');
    lightbox.querySelector('.main-product-alard__lightbox-close')?.focus();
  };

  const closeLightbox = (root) => {
    const lightbox = root.querySelector('[data-alard-lightbox]');
    if (!lightbox || lightbox.hidden) return;

    lightbox.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (lightbox.alardTrigger instanceof HTMLElement) lightbox.alardTrigger.focus();
  };

  const stepLightbox = (root, direction) => {
    const lightbox = root.querySelector('[data-alard-lightbox]');
    if (!lightbox || lightbox.hidden) return;

    const slides = getLightboxSlides(root);
    const currentIndex = Number(lightbox.dataset.activeIndex) || 0;
    showLightboxSlide(lightbox, slides, currentIndex + direction);
  };

  const initializeFaqAccordions = (root) => {
    root.querySelectorAll('[data-alard-faq-item]').forEach((item) => {
      if (item.dataset.alardFaqInitialized === 'true') return;
      item.dataset.alardFaqInitialized = 'true';

      const summary = item.querySelector('[data-alard-faq-summary]');
      const answer = item.querySelector('[data-alard-faq-answer]');
      if (!summary || !answer) return;

      summary.setAttribute('aria-expanded', String(item.open));
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (item.dataset.alardFaqAnimating === 'true') return;

        const shouldOpen = !item.open;
        summary.setAttribute('aria-expanded', String(shouldOpen));

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof item.animate !== 'function') {
          item.open = shouldOpen;
          return;
        }

        item.dataset.alardFaqAnimating = 'true';
        item.classList.toggle('is-closing', !shouldOpen);
        const collapsedHeight = summary.offsetHeight;
        let startHeight = item.offsetHeight;
        let endHeight = collapsedHeight;

        if (shouldOpen) {
          item.open = true;
          endHeight = item.offsetHeight;
          startHeight = collapsedHeight;
        }

        item.style.height = `${startHeight}px`;
        item.style.overflow = 'hidden';

        const itemAnimation = item.animate(
          { height: [`${startHeight}px`, `${endHeight}px`] },
          { duration: 280, easing: 'cubic-bezier(.22, 1, .36, 1)' }
        );
        answer.animate(
          { opacity: shouldOpen ? [0, 1] : [1, 0] },
          { duration: shouldOpen ? 240 : 180, easing: 'ease-out' }
        );

        itemAnimation.addEventListener('finish', () => {
          item.open = shouldOpen;
          item.style.removeProperty('height');
          item.style.removeProperty('overflow');
          item.classList.remove('is-closing');
          delete item.dataset.alardFaqAnimating;
        }, { once: true });
      });
    });
  };

  const moneyText = (formattedMoney) => {
    if (!formattedMoney) return '';
    const template = document.createElement('template');
    template.innerHTML = formattedMoney;
    return template.content.textContent || '';
  };

  const updateDisplayedPrice = (root, price, comparePrice, discountValue) => {
    const priceElement = root.querySelector('[data-alard-price]');
    const compareElement = root.querySelector('[data-alard-compare]');
    const discountElement = root.querySelector('[data-alard-discount]');
    const discount = Number(discountValue) || 0;

    if (priceElement && price) priceElement.textContent = moneyText(price);
    if (compareElement) {
      compareElement.textContent = moneyText(comparePrice);
      compareElement.classList.toggle('is-hidden', !comparePrice);
    }
    if (discountElement) {
      discountElement.textContent = discount > 0 ? `-${discount}%` : '';
      discountElement.classList.toggle('is-hidden', discount <= 0);
    }
  };

  const syncSubscriptionSelection = (root) => {
    const select = root.querySelector('[data-alard-selling-plan-select]');
    const subscriptionOption = root.querySelector('[data-alard-purchase-option][value="subscription"]');
    if (!select || !subscriptionOption) return false;

    let selectedPlan = select.selectedOptions[0];
    if (!selectedPlan || selectedPlan.disabled) {
      selectedPlan = Array.from(select.options).find((option) => !option.disabled);
      if (selectedPlan) select.value = selectedPlan.value;
    }

    const available = Boolean(selectedPlan && !selectedPlan.disabled && selectedPlan.dataset.price);
    subscriptionOption.disabled = !available;
    subscriptionOption.dataset.planId = available ? selectedPlan.value : '';
    subscriptionOption.dataset.price = available ? selectedPlan.dataset.price || '' : '';
    subscriptionOption.dataset.compare = available ? selectedPlan.dataset.compare || '' : '';
    subscriptionOption.dataset.discount = available ? selectedPlan.dataset.discount || '0' : '0';
    subscriptionOption.closest('.main-product-alard__purchase-option')?.classList.toggle('is-disabled', !available);

    const subscriptionLabel = root.querySelector('[data-alard-subscription-label]');
    if (subscriptionLabel) {
      const discount = available ? Number(selectedPlan.dataset.discount) || 0 : 0;
      subscriptionLabel.textContent = discount > 0 ? `Subscribe & Save ${discount}%` : 'Subscribe & Save';
    }

    return available;
  };

  const updateSellingPlansForVariant = (root, variantId) => {
    const select = root.querySelector('[data-alard-selling-plan-select]');
    if (!select) return false;

    const allocations = Array.from(root.querySelectorAll('[data-alard-plan-allocation]')).filter(
      (allocation) => allocation.dataset.variantId === String(variantId)
    );

    Array.from(select.options).forEach((option) => {
      const allocation = allocations.find((item) => item.dataset.planId === option.value);
      option.disabled = !allocation;
      option.dataset.price = allocation?.dataset.price || '';
      option.dataset.compare = allocation?.dataset.compare || '';
      option.dataset.discount = allocation?.dataset.discount || '0';
    });

    return syncSubscriptionSelection(root);
  };

  const syncPurchaseOption = (root, selectedOption) => {
    if (!selectedOption) return;

    root.querySelectorAll('.main-product-alard__purchase-option').forEach((option) => {
      option.classList.toggle('is-active', option.contains(selectedOption));
    });

    const subscription = selectedOption.value === 'subscription';
    const delivery = root.querySelector('[data-alard-delivery]');
    if (delivery) delivery.hidden = !subscription;
    const sellingPlan = root.querySelector('[data-alard-selling-plan]');
    if (sellingPlan) {
      sellingPlan.disabled = !subscription;
      sellingPlan.value = subscription ? selectedOption.dataset.planId || '' : '';
    }

    updateDisplayedPrice(
      root,
      selectedOption.dataset.price,
      selectedOption.dataset.compare,
      selectedOption.dataset.discount
    );
  };

  const setVariant = (root, button) => {
    root.querySelectorAll('[data-alard-variant]').forEach((variantButton) => {
      const active = variantButton === button;
      variantButton.classList.toggle('is-active', active);
      variantButton.setAttribute('aria-pressed', String(active));
    });

    const variantInput = root.querySelector('[data-alard-variant-input]');
    if (variantInput) variantInput.value = button.dataset.variantId;

    const unitPrice = root.querySelector('[data-alard-unit-price]');
    if (unitPrice) {
      unitPrice.textContent = button.dataset.unitPrice || '';
      unitPrice.classList.toggle('is-hidden', !button.dataset.unitPrice);
    }

    const oneTimeOption = root.querySelector('[data-alard-purchase-option][value="one-time"]');
    const subscriptionOption = root.querySelector('[data-alard-purchase-option][value="subscription"]');
    if (oneTimeOption) {
      oneTimeOption.dataset.price = button.dataset.price || '';
      oneTimeOption.dataset.compare = button.dataset.compare || '';
      oneTimeOption.dataset.discount = button.dataset.discount || '0';
    }
    if (subscriptionOption) {
      let subscriptionAvailable = updateSellingPlansForVariant(root, button.dataset.variantId);
      if (!root.querySelector('[data-alard-selling-plan-select]')) {
        subscriptionAvailable = Boolean(button.dataset.subscriptionPrice && button.dataset.subscriptionPlanId);
        subscriptionOption.dataset.price = button.dataset.subscriptionPrice || '';
        subscriptionOption.dataset.compare = button.dataset.subscriptionCompare || '';
        subscriptionOption.dataset.discount = button.dataset.subscriptionDiscount || '0';
        subscriptionOption.dataset.planId = button.dataset.subscriptionPlanId || '';
        subscriptionOption.disabled = !subscriptionAvailable;
        subscriptionOption.closest('.main-product-alard__purchase-option')?.classList.toggle('is-disabled', !subscriptionAvailable);
      }

      if (!subscriptionAvailable && subscriptionOption.checked && oneTimeOption) oneTimeOption.checked = true;
    }

    const selectedPurchaseOption = root.querySelector('[data-alard-purchase-option]:checked');
    if (selectedPurchaseOption) {
      syncPurchaseOption(root, selectedPurchaseOption);
    } else {
      updateDisplayedPrice(root, button.dataset.price, button.dataset.compare, button.dataset.discount);
    }

    const available = button.dataset.available === 'true';
    root.classList.toggle('is-selected-variant-unavailable', !available);
    const availability = root.querySelector('[data-alard-availability]');
    availability.textContent = available ? 'In stock' : 'Out of stock';
    availability.classList.toggle('is-unavailable', !available);

    const addButton = root.querySelector('.main-product-alard__add');
    const buyNowButton = root.querySelector('[data-alard-buy-now]');
    addButton.disabled = !available;
    addButton.toggleAttribute('aria-disabled', !available);
    addButton.querySelector('span').textContent = available ? 'Add to cart' : 'Sold out';
    buyNowButton.disabled = !available;

    const restock = root.querySelector('[data-alard-restock]');
    if (restock) restock.classList.toggle('is-hidden', available);
    const restockTags = root.querySelector('[data-alard-restock-tags]');
    if (restockTags) restockTags.value = `back-in-stock, back-in-stock-variant-${button.dataset.variantId}`;
    const restockVariantName = root.querySelector('[data-alard-restock-variant-name]');
    const restockVariantSeparator = root.querySelector('[data-alard-restock-separator]');
    const restockImage = root.querySelector('[data-alard-restock-image]');
    const restockNote = root.querySelector('[data-alard-restock-note]');
    const variantName = button.querySelector('.main-product-alard__variant-heading strong')?.textContent.trim() || '';
    const displayVariantName = variantName === 'Default Title' ? '' : variantName;
    if (restockVariantName) restockVariantName.textContent = displayVariantName;
    if (restockVariantSeparator) restockVariantSeparator.textContent = displayVariantName ? ' · ' : '';
    if (restockImage && button.dataset.image) restockImage.src = button.dataset.image;
    if (restockNote) restockNote.value = [root.dataset.productTitle || '', displayVariantName].filter(Boolean).join(' — ');

    updateGallery(root, button.dataset.image, button.dataset.mediaId);
    window.history.replaceState({}, '', `${window.location.pathname}?variant=${button.dataset.variantId}`);
  };

  const initializeProduct = (root) => {
    if (root.dataset.alardInitialized === 'true') return;
    root.dataset.alardInitialized = 'true';
    initializeFaqAccordions(root);
    syncSubscriptionSelection(root);
    syncPurchaseOption(root, root.querySelector('[data-alard-purchase-option]:checked'));

    let restockTrigger = null;
    const openRestockModal = (trigger) => {
      const modal = root.querySelector('[data-alard-restock-modal]');
      if (!modal) return;
      restockTrigger = trigger;
      modal.hidden = false;
      document.body.classList.add('overflow-hidden');
      window.requestAnimationFrame(() => {
        const focusTarget = modal.querySelector('[data-alard-restock-success]')
          || modal.querySelector('input[type="email"]')
          || modal.querySelector('[data-alard-restock-close]');
        focusTarget?.focus();
      });
    };
    const closeRestockModal = () => {
      const modal = root.querySelector('[data-alard-restock-modal]');
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('overflow-hidden');
      restockTrigger?.focus();
    };

    if (
      root.querySelector('[data-alard-restock-success]')
      || root.querySelector('[data-alard-restock-error]:not([hidden])')
    ) {
      openRestockModal(root.querySelector('[data-alard-restock-open]'));
    }

    const restockForm = root.querySelector('.main-product-alard__restock-form');
    restockForm?.addEventListener('submit', (event) => {
      const email = restockForm.querySelector('input[type="email"]');
      const error = restockForm.querySelector('[data-alard-restock-error]');
      const submit = restockForm.querySelector('[data-alard-restock-submit]');
      const submitLabel = restockForm.querySelector('[data-alard-restock-submit-label]');
      if (!email?.validity.valid) {
        event.preventDefault();
        email?.setAttribute('aria-invalid', 'true');
        if (error?.id) email?.setAttribute('aria-describedby', error.id);
        if (error) error.hidden = false;
        email?.focus();
        return;
      }

      email.removeAttribute('aria-invalid');
      if (error) error.hidden = true;
      if (submit) submit.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Sending...';
      restockForm.setAttribute('aria-busy', 'true');
    });

    restockForm?.querySelector('input[type="email"]')?.addEventListener('input', (event) => {
      if (!event.target.validity.valid) return;
      event.target.removeAttribute('aria-invalid');
      event.target.removeAttribute('aria-describedby');
      const error = restockForm.querySelector('[data-alard-restock-error]');
      if (error) error.hidden = true;
    });

    root.addEventListener('click', async (event) => {
      const thumbnail = event.target.closest('[data-alard-thumbnail]');
      if (thumbnail) updateGallery(root, thumbnail.dataset.image, thumbnail.dataset.mediaId, thumbnail.dataset.alt);

      const lightboxOpen = event.target.closest('[data-alard-lightbox-open]');
      if (lightboxOpen) {
        event.preventDefault();
        openLightbox(root, getActiveSlideIndex(root), lightboxOpen);
      }

      const lightboxClose = event.target.closest('[data-alard-lightbox-close]');
      if (lightboxClose) closeLightbox(root);

      const lightboxPrev = event.target.closest('[data-alard-lightbox-prev]');
      if (lightboxPrev) stepLightbox(root, -1);

      const lightboxNext = event.target.closest('[data-alard-lightbox-next]');
      if (lightboxNext) stepLightbox(root, 1);

      const variant = event.target.closest('[data-alard-variant]');
      if (variant) setVariant(root, variant);

      const restockOpen = event.target.closest('[data-alard-restock-open]');
      if (restockOpen) openRestockModal(restockOpen);

      if (event.target.closest('[data-alard-restock-close]')) closeRestockModal();

      if (event.target.closest('[data-alard-quantity-minus], [data-alard-quantity-plus]')) {
        const input = root.querySelector('[data-alard-quantity-input]');
        const direction = event.target.closest('[data-alard-quantity-plus]') ? 1 : -1;
        input.value = Math.max(Number(input.min) || 1, (Number(input.value) || 1) + direction);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const share = event.target.closest('[data-alard-share]');
      if (share) {
        try {
          if (navigator.share) await navigator.share({ title: document.title, url: window.location.href });
          else {
            await navigator.clipboard.writeText(window.location.href);
            share.setAttribute('aria-label', 'Product link copied');
          }
        } catch (error) {
          if (error.name !== 'AbortError') console.error(error);
        }
      }

      const buyNow = event.target.closest('[data-alard-buy-now]');
      if (buyNow) {
        buyNow.disabled = true;
        const form = root.querySelector('.main-product-alard__form form');
        const formData = new FormData(form);
        try {
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          if (!response.ok) throw new Error('Unable to add this product');
          window.location.assign('/checkout');
        } catch (error) {
          buyNow.disabled = false;
          const errorMessage = root.querySelector('.product-form__error-message');
          if (errorMessage) {
            errorMessage.closest('.product-form__error-message-wrapper').hidden = false;
            errorMessage.textContent = error.message;
          }
        }
      }

      const tab = event.target.closest('[data-alard-tab]');
      if (tab) {
        const name = tab.dataset.alardTab;
        root.querySelectorAll('[data-alard-tab]').forEach((button) => button.setAttribute('aria-selected', String(button === tab)));
        root.querySelectorAll('[data-alard-tab-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.alardTabPanel !== name;
        });
        if (name === 'reviews') {
          window.requestAnimationFrame(() => activateReviews(root.querySelector('[data-alard-reviews-panel]')));
        }
      }

      const tabLink = event.target.closest('[data-alard-tab-link]');
      if (tabLink) {
        event.preventDefault();
        const linkedTab = root.querySelector(`[data-alard-tab="${tabLink.dataset.alardTabLink}"]`);
        linkedTab?.click();
        root.querySelector('.main-product-alard__information')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-alard-quantity-input]')) {
        const value = Math.max(Number(event.target.min) || 1, Number(event.target.value) || 1);
        event.target.value = value;
        const formQuantity = root.querySelector('[data-alard-form-quantity]');
        if (formQuantity) formQuantity.value = value;
      }

      if (event.target.matches('[data-alard-purchase-option]')) {
        syncPurchaseOption(root, event.target);
      }

      if (event.target.matches('[data-alard-selling-plan-select]')) {
        syncSubscriptionSelection(root);
        const subscriptionOption = root.querySelector('[data-alard-purchase-option][value="subscription"]:checked');
        if (subscriptionOption) syncPurchaseOption(root, subscriptionOption);
      }
    });

    root.addEventListener('keydown', (event) => {
      const restockModal = root.querySelector('[data-alard-restock-modal]');
      if (event.key === 'Escape' && restockModal && !restockModal.hidden) {
        event.preventDefault();
        closeRestockModal();
        return;
      }

      const lightbox = root.querySelector('[data-alard-lightbox]');
      if (!lightbox || lightbox.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox(root);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        stepLightbox(root, -1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        stepLightbox(root, 1);
      }
    });
  };

  document.querySelectorAll('[data-alard-product]').forEach(initializeProduct);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-alard-product]').forEach(initializeProduct);
  });

  document.addEventListener('change', (event) => {
    const bundleItem = event.target.closest('[data-alard-bundle-item]');
    const variantSelect = event.target.closest('[data-alard-bundle-variant]');
    if (!bundleItem && !variantSelect) return;

    const bundle = event.target.closest('.main-product-alard__bundle');
    const message = bundle?.querySelector('[data-alard-bundle-message]');
    if (message) message.textContent = '';

    if (variantSelect) {
      const productCard = variantSelect.closest('.main-product-alard__bundle-product');
      const item = productCard?.querySelector('[data-alard-bundle-item]');
      const priceElement = productCard?.querySelector('[data-alard-bundle-item-price]');
      const compareElement = productCard?.querySelector('[data-alard-bundle-item-compare]');
      const option = variantSelect.selectedOptions[0];
      if (item && option) {
        item.dataset.variantId = option.value;
        item.dataset.price = option.dataset.price || '0';
        item.dataset.comparePrice = option.dataset.comparePrice || option.dataset.price || '0';
      }
      if (priceElement && option) priceElement.textContent = moneyText(option.dataset.priceFormatted);
      if (compareElement && option) {
        compareElement.textContent = moneyText(option.dataset.compareFormatted);
        compareElement.classList.toggle('is-hidden', !option.dataset.compareFormatted);
      }
    }

    updateBundle(bundle);
  });

  document.addEventListener('click', async (event) => {
    const addBundle = event.target.closest('[data-alard-add-bundle]');
    if (!addBundle) return;
    const bundle = addBundle.closest('.main-product-alard__bundle');
    const items = Array.from(bundle.querySelectorAll('[data-alard-bundle-item]:checked:not(:disabled)'))
      .map((item) => ({ id: Number(item.dataset.variantId), quantity: 1 }));
    const message = bundle.querySelector('[data-alard-bundle-message]');
    if (!items.length) {
      message.textContent = 'Choose at least one product.';
      return;
    }

    addBundle.disabled = true;
    message.textContent = 'Adding…';
    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) {
        const responseBody = await response.json().catch(() => ({}));
        throw new Error(responseBody.description || responseBody.message || 'Unable to add these products');
      }
      message.textContent = 'Added to cart.';
      window.location.assign(window.routes.cart_url);
    } catch (error) {
      message.textContent = error.message;
      addBundle.disabled = false;
    }
  });
})();
